import React from "react";

function transLoader() {
  return (
    <div className="transparent_loader">
      <div className="tl_shadow_bg" />
      <div className="tl_img">
        <img
          alt=""
          src={process.env.REACT_APP_STATIC_URL + "/images/mirror_loader.gif"}
        />
      </div>
    </div>
  );
}

export default transLoader;
